import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { KreFormFieldConfig } from "@kre-form/core";
import * as _ from "lodash";
interface Item {
  value: string;
  label: string;
  parameterId?: string;
}
@Component({
  selector: "demo-event-item",
  templateUrl: "./event-item.component.html",
  styleUrls: ["./event-item.component.scss"],
})
export class EventItemComponent implements OnInit, OnChanges {
  @Input() myForm!: FormGroup;
  @Input() index: number = 0;
  @Input() options: Item[] = [];

  @Input() field!: KreFormFieldConfig;
  @Input() fields: KreFormFieldConfig[] = [];

  // fieldType: "select" | "text" | "numbers" | "textarea" | "textBtn" = "select";

  selected: Item[] = [];
  selectItem: Item[] = [];

  changeItem: KreFormFieldConfig[] = [];

  changeToItem: Item[] = [];

  changeAction: Item[] = [];

  Includes: Item[] = [
    {
      label: "包含",
      value: "includes",
    },
    {
      label: "不包含",
      value: "notIncludes",
    },
  ];

  minIncludes: Item[] = this.Includes;
  maxLengthIncludes: Item[] = this.Includes;
  maxIncludes: Item[] = this.Includes;
  minLengthIncludes: Item[] = this.Includes;

  typeList: any[] = [
    "select",
    "text",
    "numbers",
    "textarea",
    "textBtn",
    "upload",
    "datetime",
  ];
  nzPrecision = 0;
  multiple: string = "multiple";

  editType: Item[] = [
    {
      label: "可编辑",
      value: "edit",
    },
    {
      label: "只读",
      value: "readOnly",
    },
    {
      label: "隐藏",
      value: "hide",
    },
    {
      label: "显示",
      value: "show",
    },
  ];

  RequiredType: Item[] = [
    {
      label: "必填",
      value: "required",
    },
    {
      label: "不必填",
      value: "notRequired",
    },
  ];
  IncludesType: Item[] = [
    {
      label: "包含",
      value: "includes",
    },
    {
      label: "不包含",
      value: "notIncludes",
    },
  ];

  changeToValue: Item[] = [];
  selectType: "default" | "multiple" = "default";

  selectItemType: "default" | "multiple" = "default";

  fixedValue: any = {
    minLength: null,
    maxLength: null,
    nzMax: null,
    nzMin: null,
    nzPrecision: 0,
    maxDate: null,
    minDate: null,
  };

  private selectItemList: string[] = ["selectItem", "selectItems"];
  private fieldKeyList: string[] = ["fieldKey", "changeFieldType"];

  private changeActionList: string[] = ["changeAction", "changeActions"];
  private changeToItemList: string[] = ["changeToItem", "changeToItems"];

  private lengthList: string[] = [
    "maxLength",
    "maxLengthIncludes",
    "minLength",
    "minLengthIncludes",
  ];
  private specValueList: string[] = ["specValue"];

  private numbersList: string[] = ["maxIncludes", "max", "minIncludes", "min"];
  private limit: any = {
    max: null,
    min: null,
    maxLength: null,
    minLength: null,
  };

  constructor() {}

  ngOnInit() {}

  ngOnChanges() {
    if (this.myForm.value["selected"] === "select") {
      this.selectItemList.forEach((el) => {
        this.myForm.get(el)!.setValidators(Validators.required);
      });
    }

    this.selectItem = [];
    this.changeToItem = [];
    // console.log(this.fields);

    this.fields.forEach((el: any) => {
      if (this.field.tableType === "single") {
        if (
          (this.typeList as any)!.includes(el.type) &&
          el.key !== this.field.key
        ) {
          this.changeItem!.push(el);
        }
      } else {
        if (
          (this.typeList as any)!.includes(el.type) &&
          el.key !== this.field.key &&
          (el.tableCode === this.field.tableCode || el.tableType === "single")
        ) {
          this.changeItem!.push(el);
        }
      }

      if (el.key === this.field.key) {
        this.selectItemType =
          el.templateOptions!.selectType === "multiple"
            ? "multiple"
            : "default";
      }
    });
    if (!_.isEmpty(this.options)) {
      this.options!.forEach((el: Item) => {
        if (el.parameterId === this.field!.templateOptions!.parameterId) {
          this.selectItem!.push({
            value: el!.value,
            label: el!.label,
          });
        }
        if (this.myForm.value["fieldKey"]) {
          if (
            el.parameterId ===
            this.changeItem!.filter(
              (field) => field.key === this.myForm.value["fieldKey"]
            )![0]!.templateOptions!.parameterId
          ) {
            this.changeToValue!.push({
              value: el!.value,
              label: el!.label,
            });
          }
        }
      });
    }
    if (!!this.myForm.value["fieldKey"]) {
      this.newSelectType(this.myForm.value["fieldKey"]);
    }

    let inputIsNull: Item[] = [
      {
        value: "inputIsNull",
        label: "为空",
      },
    ];

    switch (this.myForm.value["fieldType"]) {
      case "select":
        this.selected = [
          {
            value: "selected",
            label: "选中选项值",
          },
          {
            value: "selectAny",
            label: "任意选项值",
          },
        ];
        const selectIsNull: Item[] = [
          {
            value: "selectIsNull",
            label: "选项值为空",
          },
        ];

        if (this.myForm.value["required"] === false) {
          this.selected = this.selected.concat(selectIsNull);
        }

        break;
      case "upload":
        this.selected = [
          {
            value: "inputIsFill",
            label: "不为空",
          },
        ];

        if (this.myForm.value["required"] === false) {
          this.selected = this.selected.concat(inputIsNull);
        }
        break;

      case "datetime":
        this.selected = [
          {
            value: "dateTimeIsFill",
            label: "不为空",
          },
          {
            value: "dateTimeIsSpec",
            label: "特定时间",
          },
        ];
        break;
      default:
        this.selected = [
          {
            value: "inputIsFill",
            label: "不为空",
          },
          {
            value: "inputIsSpec",
            label: "特定值",
          },
        ];
        if (this.myForm.value["required"] === false) {
          this.selected = this.selected.concat(inputIsNull);
        }
        break;
    }

    if (!!this.myForm.value["changeFieldType"]) {
      this.setChangeAction();
    }
    if (!!this.myForm.value["changeActions"]) {
      this.changeActionChangeItem(this.myForm.value["changeActions"]);
    }
  }

  newSelectType(e: string) {
    if (
      !!this.changeItem.filter((el) => el.key === e)[0].templateOptions!
        .selectType
    ) {
      this.selectType =
        this.changeItem.filter((el) => el.key === e)[0].templateOptions!
          .selectType === "multiple"
          ? "multiple"
          : "default";
      this.multiple = this.selectType;
      if (
        (["hideState", "showState"] as any).includes(
          this.myForm.value["changeToItems"]
        )
      ) {
        this.multiple = this.selectType = "multiple";
      }
    } else {
      this.selectType = "default";
    }
    this.initFixedValueOne(this.changeItem.filter((el) => el.key === e)[0]);
  }

  selectedChange(e: string) {
    const list: string[] = [
      ...this.selectItemList,
      ...this.fieldKeyList,
      ...this.changeActionList,
      ...this.changeToItemList,
      ...this.lengthList,
      ...this.numbersList,
      ...this.specValueList,
    ];
    this.setValueToNull(list);
    if (this.myForm.value["selected"] === "selected") {
      this.selectItemList.forEach((el) => {
        this.myForm.get(el)!.setValidators(Validators.required);
      });
      (this.myForm as any)!.get("specValue").clearValidators();
      (this.myForm as any)!.get("specValue")!.reset();
    } else {
      if (this.myForm.value["selected"] === "inputIsSpec") {
        this.myForm.get("specValue")!.setValidators(Validators.required);
        this.myForm.get("specValue")!.reset();
      } else {
        this.myForm.get("specValue")!.clearValidators();
        this.myForm.get("specValue")!.reset();
      }
      this.selectItemList.forEach((el) => {
        this.myForm.get(el)!.clearValidators();
        this.myForm.get(el)!.reset();
      });
    }
  }
  setValueToNull(list: string[]) {
    if (!_.isEmpty(list)) {
      list.forEach((el) => {
        this.myForm.controls[el].setValue(null);
        this.myForm.controls[el].setErrors(null);
      });
    }
    this.myForm.controls["fixedValue"].setValue(null);
    this.myForm.get("fixedValue")!.clearValidators();
  }
  selectItemChange(e: any) {
    if (!!e && e.length > 0) {
      let list: Item[] = [];
      this.selectItem.forEach((el: any) => {
        if (e!.includes(el.value)) {
          list!.push(el);
        }
      });
      this.myForm.controls.selectItem.setValue(null);
      this.myForm.controls.selectItem.setValue(list);
    } else {
      this.myForm.controls.selectItem.setValue(null);
    }
  }

  changeToItemChange(e: any | string) {
    if (!!e && Array.isArray(e)) {
      let list: Item[] = [];
      const valueList: any[] = e;
      this.changeToItem.forEach((el) => {
        if ((valueList as any)!.includes(el.value)) {
          list!.push(el);
        }
      });
      this.myForm.controls.changeToItem.setValue(null);
      this.myForm.controls.changeToItem.setValue(list);
    } else {
      const value: string = e as string;
      if (!!e) {
        let list: Item[] = [];
        this.changeToItem.forEach((el) => {
          if (value === el.value) {
            list!.push(el);
          }
        });
        this.myForm.controls.changeToItem.setValue(null);
        this.myForm.controls.changeToItem.setValue(list);
      }
    }
  }

  fieldKeyChange(e: string) {
    const list: string[] = [
      ...this.changeActionList,
      ...this.changeToItemList,
      ...this.lengthList,
      ...this.numbersList,
    ];
    this.changeToItem = [];
    this.setValueToNull(list);

    if ((this.changeItem.filter((el) => el.key === e) as any[]).length > 0) {
      const field: any = this.changeItem.filter((el) => el.key === e)[0];
      this.myForm.controls.changeFieldType.setValue(field.type);
      this.myForm.controls.changeFieldName.setValue(
        field!.templateOptions!.label
      );
      this.nzPrecision = field!.templateOptions.precision || 0;
      this.limit.max = field!.templateOptions!.max || null;
      this.limit.min = field!.templateOptions!.min || null;
      this.limit.maxLength = field!.templateOptions!.maxLength || null;
      this.limit.minLength = field!.templateOptions!.minLength || null;

      this.initFixedValueOne(field);
      this.newSelectType(e);
      if (!_.isEmpty(this.options)) {
        this.changeToValue = [];
        this.options.forEach((el: Item) => {
          if (el.parameterId === field!.templateOptions!.parameterId) {
            this.changeToValue!.push({
              value: el!.value,
              label: el!.label,
            });
          }
        });
      }
    }

    this.setChangeAction();
  }
  newPrimitive(value: any) {
    if (
      value.primitiveProperty === null ||
      value.primitiveProperty === undefined
    ) {
      value.primitiveProperty = {};
    }

    const list = [
      "maxLength",
      "minLength",
      "max",
      "min",
      "precision",
      "maxDate",
      "minDate",
    ];
    list.forEach((key) => {
      if (
        value.primitiveProperty[key] === null ||
        value.primitiveProperty[key] === undefined
      ) {
        value.primitiveProperty[key] = value.templateOptions[key];
      }
    });
  }

  initFixedValueOne(field: KreFormFieldConfig) {
    this.newPrimitive(field);
    this.fixedValue.minLength =
      field.templateOptions!.minLength ||
      field!.primitiveProperty!.minLength ||
      0;
    this.fixedValue.maxLength =
      field.templateOptions!.maxLength ||
      field!.primitiveProperty!.maxLength ||
      500;
    this.fixedValue.nzPrecision =
      field.templateOptions!.precision ||
      field!.primitiveProperty!.precision ||
      0;
    this.fixedValue.max =
      field.templateOptions!.max || field!.primitiveProperty!.max || 999999;
    this.fixedValue.min =
      field.templateOptions!.min || field!.primitiveProperty!.min || -999999;

    this.fixedValue.maxDate =
      field.templateOptions!.maxDate ||
      field!.primitiveProperty!.maxDate ||
      "2050-12-31";

    this.fixedValue.minDate =
      field.templateOptions!.minDate ||
      field!.primitiveProperty!.minDate ||
      "1900-01-01";
  }

  setFixedValueValidators() {
    if (!!this.fixedValue.min || this.fixedValue.min === 0) {
      this.myForm
        .get("fixedValue")!
        .setValidators(Validators.min(this.fixedValue.min));
    }
    if (!!this.fixedValue.minLength) {
      this.myForm
        .get("fixedValue")!
        .setValidators(Validators.minLength(this.fixedValue.minLength));
    }
    if (!!this.fixedValue.max) {
      this.myForm
        .get("fixedValue")!
        .setValidators(Validators.max(this.fixedValue.max));
    }
    if (!!this.fixedValue.maxLength) {
      this.myForm
        .get("fixedValue")!
        .setValidators(Validators.maxLength(this.fixedValue.maxLength));
    }
  }

  setChangeAction() {
    const requireList: any[] = [
      {
        value: "requireState",
        label: "必填状态变更",
      },
    ];
    if (!!this.myForm.value["changeFieldType"]) {
      if (this.myForm.value["changeFieldType"] === "select") {
        this.changeAction = [
          {
            value: "valueChange",
            label: "值变更",
          },
          {
            value: "editState",
            label: "编辑状态变更",
          },
          {
            value: "hideState",
            label: "隐藏选项值",
          },
          {
            value: "showState",
            label: "提供选项值",
          },
        ];
      } else if (this.myForm.value["changeFieldType"] === "numbers") {
        this.changeAction = [
          {
            value: "fixedValueChange",
            label: "固定值变更",
          },
          {
            value: "limitNumber",
            label: "限定数值范围",
          },
          {
            value: "editState",
            label: "编辑状态变更",
          },
        ];
      } else if (this.myForm.value["changeFieldType"] === "upload") {
        this.changeAction = [
          {
            value: "editState",
            label: "编辑状态变更",
          },
        ];
      } else if (this.myForm.value["changeFieldType"] === "datetime") {
        this.changeAction = [
          {
            value: "fixedValueChange",
            label: "固定值变更",
          },
          {
            value: "editState",
            label: "编辑状态变更",
          },
          {
            value: "limitDateTime",
            label: "限定时间范围",
          },
        ];
      } else {
        this.changeAction = [
          {
            value: "fixedValueChange",
            label: "固定值变更",
          },
          {
            value: "limitLength",
            label: "限定字符长度",
          },
          {
            value: "editState",
            label: "编辑状态变更",
          },
        ];
      }
    }

    if (
      !!this.myForm.value["fieldKey"] &&
      !this.changeItem!.filter(
        (el) => el.key === this.myForm.value["fieldKey"]
      )![0]!.templateOptions!.required
    ) {
      this.changeAction = this.changeAction.concat(requireList);
    }
  }

  changeActionChange(
    type:
      | "valueChange"
      | "editState"
      | "requireState"
      | "hideState"
      | "showState"
      | "limitLength"
      | "limitNumber"
      | "fixedValueChange"
  ) {
    const list: string[] = [
      ...this.changeToItemList,
      ...this.lengthList,
      ...this.numbersList,
    ];
    this.setValueToNull(list);

    if (!!type) {
      this.myForm.controls.changeAction.setValue(
        this.changeAction.filter((el) => el.value === type)
      );
    } else {
      this.myForm.controls.changeAction.setValue(null);
    }
    this.changeActionChangeItem(type);
    if (!!this.myForm.value["fieldKey"]) {
      const field: KreFormFieldConfig = this.changeItem.filter(
        (el) => el.key === this.myForm.value["fieldKey"]
      )[0];

      this.initFixedValue(field);
    }
  }

  changeActionChangeItem(
    type:
      | "valueChange"
      | "editState"
      | "requireState"
      | "hideState"
      | "showState"
      | "limitLength"
      | "limitNumber"
      | "fixedValueChange"
  ) {
    this.changeToItemList.forEach((el) => {
      this.myForm.get(el)!.setValidators(Validators.required);
    });

    [...this.lengthList, ...this.numbersList].forEach((el) => {
      this.myForm.get(el)!.clearValidators();
    });
    switch (type) {
      case "valueChange":
        this.changeToItem = this.changeToValue;
        this.multiple = this.selectType;
        break;

      case "hideState":
      case "showState":
        this.changeToItem = this.changeToValue;
        this.multiple = "multiple";
        break;
      case "editState":
        this.changeToItem = this.editType;
        this.multiple = "default";

        break;
      case "requireState":
        this.changeToItem = this.RequiredType;
        this.multiple = "default";

        break;

      case "limitLength":
        this.changeToItem = [];

        this.changeToItemList.forEach((el) => {
          this.myForm.get(el)!.clearValidators();
        });
        if (!this.myForm.value["maxLengthIncludes"]) {
          this.myForm.get("maxLengthIncludes")!.setValue("includes");
        }
        if (!this.myForm.value["minLengthIncludes"]) {
          this.myForm.get("minLengthIncludes")!.setValue("includes");
        }

        this.myForm.get("maxLength")!.setValidators([Validators.required]);
        this.myForm.get("minLength")!.setValidators([Validators.required]);

        break;

      case "limitNumber":
        this.changeToItem = [];

        this.changeToItemList.forEach((el) => {
          this.myForm.get(el)!.clearValidators();
        });

        if (!this.myForm.value["maxIncludes"]) {
          this.myForm.get("maxIncludes")!.setValue("includes");
        }
        if (!this.myForm.value["minIncludes"]) {
          this.myForm.get("minIncludes")!.setValue("includes");
        }

        this.myForm.get("max")!.setValidators([Validators.required]);
        this.myForm.get("min")!.setValidators([Validators.required]);

        break;
      case "fixedValueChange":
        this.changeToItem = [];
        this.changeToItemList.forEach((el) => {
          this.myForm.get(el)!.clearValidators();
        });
        break;

      default:
        break;
    }
  }
  minNzMax(): number {
    let num = 999999;
    if (!!this.limit!.max) {
      num = this.limit!.max;
    }
    if (!!this.myForm!.value!.max) {
      num = this.myForm!.value!.max;
    }
    return num;
  }
  minNzMin(): number {
    let num = null;
    if (!!this.limit!.min) {
      num = this.limit!.min;
    }
    return num;
  }

  maxNzMax(): number {
    let num = 999999;
    if (!!this.limit!.max) {
      num = this.limit!.max;
    }
    return num;
  }
  maxNzMin(): number {
    let num = null;
    if (!!this.limit!.min) {
      num = this.limit!.min;
    }
    if (!!this.myForm!.value!.min) {
      num = this.myForm!.value!.min;
    }
    return num;
  }
  ///////////////////////////////////////////////////

  minLengthNzMax(): number {
    let num = 500;
    if (!!this.limit!.maxLength) {
      num = this.limit!.maxLength;
    }
    if (!!this.myForm!.value!.maxLength) {
      num = this.myForm!.value!.maxLength;
    }
    return num;
  }
  minLengthNzMin(): number {
    let num = 0;
    if (!!this.limit!.minLength) {
      num = this.limit!.minLength;
    }
    return num;
  }

  maxLengthNzMax(): number {
    let num = 500;
    if (!!this.limit!.maxLength) {
      num = this.limit!.maxLength;
    }
    return num;
  }
  maxLengthNzMin(): number {
    let num = null;
    if (!!this.limit!.minLength) {
      num = this.limit!.minLength;
    }
    if (!!this.myForm!.value!.minLength) {
      num = this.myForm!.value!.minLength;
    }
    return num;
  }
  // 获取限定值
  initFixedValue(field: KreFormFieldConfig) {
    this.initFixedValueOne(field);
    const eventList: any[] = this.myForm.root.value["eventList"];
    if (!_.isEmpty(eventList)) {
      const otherList: any[] = eventList!.filter(
        (el: any) =>
          el.code !== this.myForm.value["code"] &&
          el.fieldKey === this.myForm.value["fieldKey"]
      );
      if (!_.isEmpty(otherList)) {
        const maxList: any[] = [];
        const minList: any[] = [];
        const maxLengthList: any[] = [];
        const minLengthList: any[] = [];
        let min = Math.max.apply(
          Math,
          otherList.map((el: any) => {
            return el.min;
          })
        );
        let max = Math.min.apply(
          Math,
          otherList.map((el: any) => {
            return el.max;
          })
        );

        let minLength = Math.max.apply(
          Math,
          otherList.map((el: any) => {
            return el.minLength;
          })
        );
        let maxLength = Math.min.apply(
          Math,
          otherList.map((el: any) => {
            return el.maxLength;
          })
        );

        if (!!min || min === 0) {
          otherList.forEach((el: any) => {
            if (el.min === min) {
              minList.push(el);
            }
          });
        }
        if (!!max || max === 0) {
          otherList.forEach((el: any) => {
            if (el.max === max) {
              maxList.push(el);
            }
          });
        }
        if (!!maxLength || maxLength === 0) {
          otherList.forEach((el: any) => {
            if (el.maxLength === maxLength) {
              maxLengthList.push(el);
            }
          });
        }
        if (!!minLength || minLength === 0) {
          otherList.forEach((el: any) => {
            if (el.minLength === minLength) {
              minLengthList.push(el);
            }
          });
        }
        if (!_.isEmpty(maxList)) {
          if (maxList.some((el: any) => el.maxIncludes === "notIncludes")) {
            this.fixedValue.max = Math.min(this.fixedValue.max, max - 1);
          } else {
            this.fixedValue.max = Math.min(this.fixedValue.max, max);
          }
        }
        if (!_.isEmpty(minList)) {
          if (minList.some((el: any) => el.minIncludes === "notIncludes")) {
            this.fixedValue.min = Math.max(this.fixedValue.min, min - 1);
          } else {
            this.fixedValue.min = Math.max(this.fixedValue.min, min);
          }
        }

        if (!_.isEmpty(minLengthList)) {
          if (
            minLengthList.some(
              (el: any) => el.minLengthIncludes === "notIncludes"
            )
          ) {
            this.fixedValue.minLength = Math.max(
              this.fixedValue.minLength,
              minLength - 1
            );
          } else {
            this.fixedValue.minLength = Math.max(
              this.fixedValue.minLength,
              minLength
            );
          }
        }

        if (!_.isEmpty(maxLengthList)) {
          if (
            maxLengthList.some(
              (el: any) => el.maxLengthIncludes === "notIncludes"
            )
          ) {
            this.fixedValue.maxLength = Math.min(
              this.fixedValue.maxLength,
              maxLength - 1
            );
          } else {
            this.fixedValue.maxLength = Math.min(
              this.fixedValue.maxLength,
              maxLength
            );
          }
        }
      }
    }
    this.setFixedValueValidators();
  }
}
